export const TOOL_LABELS = {
  get_semantic_schema: 'Схема данных',
  get_filter_options: 'Значения фильтров',
  query_data: 'Запрос данных',
  add_table: 'Таблица',
  build_chart: 'График',
  execute_sql: 'SQL-запрос',
  export_file: 'Выгрузка',
  calculate_deal: 'Расчёт сделки',
  get_trip_details: 'Карточка рейса',
  ask_user: 'Уточнения',
  remember: 'Заметка в память',
  search_memories: 'Поиск по памяти',
  read_memory: 'Чтение памяти',
};
